import React from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import R from 'ramda'


import Carousel from './Carousel'
import EstateDescription from './EstateDescription'
import LikeButton from './LikeButton'
import EstateProximity from './EstateProximity'
import Elipsis from './Elipsis'
import Spacer from './Spacer'
import EstatePartner from './EstatePartner'
import Icon from './Icon'
import StatelessFuncToPureComponent from './StatelessFuncToPureComponent'
import MoreButton from './MoreButton'

import Price from './Price'

import {estatePhoto} from 'conf'

import photoUrlFormatter from '../utils/photoUrlFormatter' 

const EstateBigCard = ({id, photos, description, features, address, price, like, rooms,  partner, providerUrl, detailsUrl, onClick, proximityScore}) => {
  const format = (filename) => photoUrlFormatter(filename, id, 600) 
  const extractUrlFromPhoto = R.pipe(R.prop('url'), format, estatePhoto)
  const photosUrls = photos.length ? R.map(extractUrlFromPhoto, photos) : ["images/estate/maison_600.png"]

  return <div> 
    <div  className="panel panel-default" style={{borderStyle:'solid', borderWidth:'3px', borderColor:'#0198be' }}>

      <div style={{position:'absolute', zIndex:'100'}}>
        <EstatePartner partner={partner} providerUrl={providerUrl} selected={true}/>  
      </div>

      <div className="estate-card-label" style={{position:'absolute', right:'3px', paddingRight:'2px', paddingLeft:'5px', zIndex:'100'}}>
        <Price amount={price} currency='CAD'/>
      </div>

      <div className="estate-card-label" style={{position:'absolute', right:'3px', top:'32px', paddingRight:'2px', paddingLeft:'5px', zIndex:'100'}}>
        <LikeButton estateId={id} like={like}/>
      </div>
      
      <div className="estate-card-label proximity" style={{position:'absolute', left:'3px', bottom:'3px', paddingRight:'2px', paddingLeft:'5px', zIndex:'100'}}>
        <EstateProximity proximityInSeconds={proximityScore} />
      </div>

      <div className="panel-body">
        <Carousel images={photosUrls} />
        <div className="big-estate-body" style={{marginBottom:'0px', marginRight:'10px'}}>
          <EstateDescription id={id}
                             like={like}
                             address={address}
                             price={price}
                             rooms={rooms}
                             partner={partner}
                             providerUrl={providerUrl}
                             detailsUrl={detailsUrl}
                             features={features}
                             proximityScore={proximityScore}/>
                     
          <Elipsis text={description} length={500}/>

          <div className="estate-price" >
            <div style={{display:'flex', justifyContent: 'flex-end', marginRight:'10px'}}>
              <a href={detailsUrl} target='_blank' rel='noopener' style={{marginRight:'5px'}}>
                <FormattedMessage
                  id="Details"
                  defaultMessage="Details"/>
              </a>
            </div>
          </div>

        </div>
      </div>
      <MoreButton text="▲"/>
    </div>
  </div>;
  }

EstateBigCard.PropTypes = {
  id: React.PropTypes.number.isRequied,
  like: React.PropTypes.bool,
  description: React.PropTypes.string.isRequired,
  photos: React.PropTypes.array.isRequired,
  address: React.PropTypes.string.isRequired,
  price: React.PropTypes.number.isRequired,
  rooms: React.PropTypes.number.isRequired,
  partner: React.PropTypes.string,
  providerUrl: React.PropTypes.string.isRequired,
  detailsUrl: React.PropTypes.string.isRequired,
  options: React.PropTypes.object.isRequired,
  proximityScore: React.PropTypes.number.isRequired,
}
export default StatelessFuncToPureComponent(EstateBigCard)



/** WEBPACK FOOTER **
 ** ./app/components/EstateBigCard.jsx
 **/